<template>
    <div class="vx-row">
        <div class="vx-col md:w-2/2 w-full mb-base">
            <vx-card title="Update User Data">
                <div class="vx-row mb-2" v-if=currentUser.isInternal>
                    <div class="vx-col w-full">
                        <ul class="centerx">
                            <li>
                                <vs-radio id="rdo-user-internal" v-model="NewUserGroup" vs-value="aino" @change="updateRolesData">
                                    Internal user
                                </vs-radio>
                            </li>
                            <li>
                                <vs-radio id="rdo-user-merchant" v-model="NewUserGroup" vs-value="merchant"
                                          @change="updateRolesData">Merchant user
                                </vs-radio>
                            </li>
                            <li>
                                <vs-radio id="rdo-user-issuer" v-model="NewUserGroup" vs-value="issuer"
                                          @change="updateRolesData">Issuer user
                                </vs-radio>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="vx-row mb-6" v-if="NewUserGroup === 'merchant'">
                    <div class="vx-col w-full">
                        <vs-select id="cbo-merchant" name="Merchant" description-text="Select a merchant" placeholder="Select merchant"
                                   label="Merchant" v-model="merchant_id" v-validate="'required'">
                            <vs-select-item v-bind:id="'cbo-merchant-'+merchant.id" :key="merchant.id" :value="merchant.id" :text="merchant.full_name"
                                            v-for="merchant in merchants"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors.first('Merchant') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6" v-if="NewUserGroup === 'issuer'">
                    <div class="vx-col w-full">
                        <vs-select id="cbo-issuer" name="Issuer" description-text="Select a issuer" placeholder="Select issuer"
                                   label="Issuer" v-model="issuer_id" v-validate="'required'">
                            <vs-select-item v-bind:id="'cbo-issuer'+issuer.id" :key="issuer.id" :value="issuer.id" :text="issuer.name"
                                            v-for="issuer in issuers"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors.first('Issuer') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full">
                        <vs-input id="txt-username" class="w-full" name="Name" icon-pack="feather" icon="icon-user" icon-no-border
                                  label-placeholder="Username" v-model="data.username"
                                  v-validate="'required'"/>
                        <span class="text-danger text-sm">{{ errors.first('Name') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full">
                        <vs-input id="txt-email" type="email" name="Email" class="w-full" icon-pack="feather" icon="icon-mail"
                                  icon-no-border
                                  label-placeholder="Email" v-model="data.email"
                                  v-validate="'required|email'"/>
                        <span class="text-danger text-sm">{{ errors.first('Email') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-input id="txt-password" type="password" name="Password" class="w-full" icon-pack="feather" icon="icon-lock"
                                  icon-no-border
                                  label-placeholder="New Password" v-model="data.password"
                                  v-validate="'min:8|verify_password'"/>
                        <span class="text-danger text-sm">{{ errors.first('Password') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-select id="cbo-role" name="User roles" description-text="Select a user roles" placeholder="Select role"
                                   label="User roles" v-model="data.role_id" v-validate="'required'">
                            <vs-select-item v-bind:id="'cbo-role-'+role.id" :key="role.id" :value="role.id" :text="role.name" v-for="role in roles"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors.first('User roles') }}</span>
                    </div>
                </div>
                <br/>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-button id="btn-save" color="success" type="filled" class="mb-2" icon-pack="feather" icon="icon-save"
                                   @click.prevent="updateUser">Save
                        </vs-button>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    import AxiosCall from "@/global/AxiosCall";
    import {url} from '@/configs/apiUrl'
    import swal from "sweetalert2"

    export default {
        name: "EditUserManagement",
        data() {
            return {
                defaultUserGroup: '',
                defaultRoleId: '',
                NewUserGroup: "aino",
                data: {
                    username: "",
                    password: "",
                    email: "",
                    role_ids: [],
                    role_id: '',
                    merchant_id: '',
                    issuer_id: '',
                },
                roles: [],
                currentUser: {
                    id: 0,
                    group: "",
                    isInternal: false,
                },
                merchant_id: '',
                issuer_id: '',
                merchants: [],
                issuers: [],
                auditUser: {
                    user_id: "",
                    session_id: "",
                    user_name: "",
                    menu: "",
                    activity: "",
                    data_before: {},
                    data_after: {},
                },
                dataBefore: {
                    username: "",
                    password: "",
                    email: "",
                    role_ids: [],
                    role_id: '',
                    merchant_id: '',
                    issuer_id: '',
                },
            }
        },
        methods: {
            openLoading() {
                this.$vs.loading({
                    type: 'default',
                })
            },
            warning(title, text) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: 'warning',
                    position: 'top-right'
                })
            },
            success(title, text) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: 'success',
                    position: 'top-right'
                })
            },
            danger(title, text) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: 'danger',
                    position: 'top-right'
                })
            },
            updateRolesData() {
                this.data.role_id = ''
                let group = this.NewUserGroup

                AxiosCall.Get(url.svd.roles.list + "?group=" + group).then(response => {
                    console.log(response)
                    if (response.code == 200) {
                        this.roles = response.data
                        if (this.roles.filter(x => x.id === this.defaultRoleId).length !== 0){
                            this.data.role_id = this.defaultRoleId
                        }
                    } else {
                        this.danger("Error", "Retrieve roles data failed (" + response.message + ")")
                    }
                })

                if (this.defaultUserGroup === 'aino') {
                    this.merchant_id = ''
                    this.issuer_id = ''
                } else if (this.defaultUserGroup === 'merchant') {
                    this.merchant_id = this.data.merchant_id
                    this.issuer_id = ''
                } else if (this.defaultUserGroup === 'issuer') {
                    this.merchant_id = ''
                    this.issuer_id = this.data.issuer_id
                }
            },
            updateUser() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.data.role_ids = [this.data.role_id]
                        if (this.NewUserGroup === 'aino')
                            this.data.merchant_id = 0
                        else {
                            this.data.merchant_id = this.merchant_id
                            this.data.issuer_id = this.issuer_id
                        }

                        let check_role_id = this.data.role_id
                        let check_role_slug = ''
                        for (let i in this.roles) {
                          if (this.roles[i].id===check_role_id) {
                            check_role_slug = this.roles[i].slug
                          }
                        }
                        if (check_role_slug==='merchant_admin' && this.data.password.length >= 8) {
                          this.updateUserMerchantAdmin(this.data)
                          return
                        }

                        this.openLoading()
                        AxiosCall.Put(url.svd.user.update + this.$route.params.id, this.data).then(resp => {
                            this.$vs.loading.close()
                            if (resp.code == 200) {
                                this.success('Success', "User data successfully updated")
                                this.data.password = '******'
                                this.$store.dispatch('createAuditTrail', {
                                    user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                                    session_id: parseInt(localStorage.getItem('sessID')),
                                    user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                                    menu:      "User Management",
                                    activity: "Edit User",
                                    data_before: this.dataBefore,
                                    data_after: this.data,
                                })
                                return
                            }
                            this.danger('Error', "Couldn't update user data")
                        }).catch((e) => {
                            console.log(e)
                            this.$vs.loading.close()
                            if (e.response.hasOwnProperty("data")) {
                              if (e.response.data.hasOwnProperty("code")) {
                                if (e.response.data.code===409) {
                                  this.danger('Error', e.response.data.message)
                                  return
                                }
                              }
                            }
                            this.danger('Error', "Couldn't update user data")
                        })
                    }
                })
            },
            updateUserMerchantAdmin(dataMerchant) {
              swal.fire({
                title: 'Are you ready to change password ?',
                text: "Because it will impact to device transaction when this user has role as a merchant admin",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, i admit it !'
              }).then((result) => {
                if (result.value) {
                  this.openLoading()
                  AxiosCall.Put(url.svd.user.update + this.$route.params.id, dataMerchant).then(resp => {
                    this.$vs.loading.close()
                    if (resp.code == 200) {
                        this.success('Success', "User data successfully updated")
                        this.data.password = '******'
                        this.$store.dispatch('createAuditTrail', {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "User Management",
                            activity: "Edit User",
                            data_before: this.dataBefore,
                            data_after: this.data,
                        })
                      return
                    }
                    this.danger('Error', "Couldn't update user data")
                  }).catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                    if (e.response.hasOwnProperty("data")) {
                      if (e.response.data.hasOwnProperty("code")) {
                        if (e.response.data.code===409) {
                          this.danger('Error', e.response.data.message)
                          return
                        }
                      }
                    }
                    this.danger('Error', "Couldn't update user data")
                  })
                } else {
                  return
                }
              })
            }
        },
        beforeMount(){
            if (this.$route.params.id !== undefined) {
               AxiosCall.Get(url.svd.user.detail + this.$route.params.id).then(response => {
                    if (response.code == 200) {
                        this.dataBefore = response.data
                        this.dataBefore.password = '******'
                        this.dataBefore.role_id = response.data.role_ids[0].role_id
                        this.defaultRoleId = response.data.role_ids[0].role_id
                        if (this.dataBefore.merchants.length !== 0) {
                            this.merchant_id = this.dataBefore.merchants[0].id
                            this.dataBefore.merchant_id = this.dataBefore.merchants[0].id
                        } else {
                            this.dataBefore.merchant_id = ''
                        }

                        if (this.dataBefore.issuers.length !== 0) {
                            this.issuer_id = this.dataBefore.issuers[0].id
                            this.dataBefore.issuer_id = this.dataBefore.issuers[0].id
                        } else {
                            this.dataBefore.issuer_id = ''
                        }
                    } else {
                        this.danger("Error : Retrieve user data failed", "Couldn't retrieve user data (" + response.message + ")")
                    }
                })
            }
        },
        mounted() {
            AxiosCall.Get(url.svd.merchant.list).then(response => {
                if (response.code == 200) {
                    this.merchants = response.data
                } else {
                    this.danger("Error", "Retrieve roles data failed (" + response.message + ")")
                }
            })

            AxiosCall.Get(url.backoffice.issuer.list).then(response => {
                if (response.code == 200) {
                    this.issuers = response.data
                } else {
                    this.danger("Error", "Retrieve roles data failed (" + response.message + ")")
                }
            })

            try {
                var userData = JSON.parse(localStorage.getItem("userInfo"))
                this.currentUser.id = userData.id
                var authToken = userData.access_token.token
                AxiosCall.GetUserFromToken(url.svd.auth.me, {authToken: authToken}).then(response => {
                    if (response.data.code == 200) {
                        //todo remove condition
                        if (typeof response.data.data.roles[0] == 'string') {
                            this.currentUser.group = 'aino'
                        } else {
                            this.currentUser.group = response.data.data.roles[0].group
                        }

                        if (this.currentUser.group === 'aino') {
                            this.currentUser.isInternal = true
                        }
                    } else {
                        this.danger("Error", "Retrieve user data failed (" + response.message + ")")
                    }
                })
            } catch (e) {
                console.log(e)
            }

            if (this.$route.params.id !== undefined) {
               AxiosCall.Get(url.svd.user.detail + this.$route.params.id).then(response => {
                    if (response.code == 200) {
                        this.data = response.data
                        this.data.password = ''
                        this.data.role_id = response.data.role_ids[0].role_id
                        this.defaultRoleId = response.data.role_ids[0].role_id
                        if (this.data.merchants.length !== 0) {
                            this.merchant_id = this.data.merchants[0].id
                            this.data.merchant_id = this.data.merchants[0].id
                        } else {
                            this.data.merchant_id = ''
                        }

                        if (this.data.issuers.length !== 0) {
                            this.issuer_id = this.data.issuers[0].id
                            this.data.issuer_id = this.data.issuers[0].id
                        } else {
                            this.data.issuer_id = ''
                        }
                        this.NewUserGroup = this.data.role_details[0].group
                        this.defaultUserGroup = this.data.role_details[0].group
                        this.updateRolesData()
                    } else {
                        this.danger("Error : Retrieve user data failed", "Couldn't retrieve user data (" + response.message + ")")
                    }
                })
            }
        },
        props: {
            id_merchant: {
                type: Number
            }
        }
    }
</script>

<style scoped>

</style>